import allPromisesWithRetries from '@/helpers/allPromisesWithRetries'
import { log } from '@/services/Log'
import { BCCheckoutType } from '@/types/BigCommerce/BCCheckout'
import { StandardOrder } from '@/types/ShopFront/CheckoutStandards'
//---------------------------------------------------------------
// Updates an existing consignment. - https://developer.bigcommerce.com/api-reference/storefront/checkouts/checkout-consignments/checkoutsconsignmentsbycheckoutidandconsignmentidput
// Shipping address, line item IDs or the shipping option ID can be updated using this endpoint.
export const updateShippingOption = async ({
  order, shipmentId, shippingOptionId,
}: {
  order: StandardOrder, shipmentId: string, shippingOptionId: string,
}) => {
  log('updateShippingOption START', { order, shipmentId, shippingOptionId })
  // TODO: verify if this operation can be using expired consignment IDs
  const [
    { default: Axios },
    { getCartFromResponse },
    { recoverShippingOptions },
    { standardizeOrder },
    { areAllShipmentsAssigned },
  ] = await allPromisesWithRetries(() => [
    import('axios'),
    import('@/services/FramedCheckout/cartServices/getCartFromResponse'),
    import('@/services/FramedCheckout/shipmentServices/recoverShippingOptions'),
    import('@/services/Standardizers/standardizeOrder'),
    import('@/helpers/areAllShipmentsAssigned'),
  ])

  const standardizeOrderFromResponse = ({ bigcResponse, order }) => {
    const cart = getCartFromResponse(bigcResponse?.cart, order)
    return standardizeOrder(bigcResponse, cart)
  }
  const { data, status } = await Axios.put<BCCheckoutType>(
    `/api/storefront/checkouts/${order?.cart?.id}/consignments/${shipmentId}?include=consignments.availableShippingOptions`,
    { shippingOptionId },
  )
  const newOrder = await standardizeOrderFromResponse({ order, bigcResponse: data })
  const allShipmentsAssigned = areAllShipmentsAssigned(newOrder)
  log('updateShippingOption END', { success: status === 200, newOrder, areAllShipmentsAssigned: allShipmentsAssigned })
  if (!allShipmentsAssigned) {
    return recoverShippingOptions({ order, newOrder, newCart: newOrder.cart })
  }
  return { success: status === 200, newOrder }
}

export default updateShippingOption
